module.exports = __webpack_public_path__ + "media/myplan-1080.566151c5.mp4";